import { AppDataActions } from 'misc/enums';
import { Button } from '@chakra-ui/react';
import React from 'react';
import { RepeatClockIcon } from '@chakra-ui/icons';
import { useAppDataContext } from 'misc/appDataCtxt';

export const ButtonClearFilter = () => {
  const { dispatch } = useAppDataContext();
  return (
    <Button
      leftIcon={<RepeatClockIcon />}
      colorScheme={'teal'}
      shadow={'md'}
      onClick={() =>
        dispatch({
          type: AppDataActions.resetAllFilters,
        })
      }
    >
      Effacer
    </Button>
  );
};
